
let isLogin=(username)=> username === 'najm' ? true : false


let ramlKey=[
{id:1,keynum:"0111",keyA:'a',src:'./images/ashkal16/1.png '},
{id:1,keynum:'1011',keyA:'b',src:'./images/ashkal16/2.png '},
{id:1,keynum:'0011',keyA:'c',src:'./images/ashkal16/3.png '},
{id:1,keynum:'1101',keyA:'d',src:'./images/ashkal16/4.png '},
{id:1,keynum:'0101',keyA:'e',src:'./images/ashkal16/5.png '},
{id:1,keynum:'1001',keyA:'f',src:'./images/ashkal16/6.png '},
{id:1,keynum:'1000',keyA:'g',src:'./images/ashkal16/14.png '},
{id:1,keynum:'1110',keyA:'h',src:'./images/ashkal16/8.png '},
{id:1,keynum:'0110',keyA:'i',src:'./images/ashkal16/9.png '},
{id:1,keynum:'1010',keyA:'j',src:'./images/ashkal16/10.png '},
{id:1,keynum:'0010',keyA:'k',src:'./images/ashkal16/11.png '},
{id:1,keynum:'1100',keyA:'l',src:'./images/ashkal16/12.png '},
{id:1,keynum:'0100',keyA:'m',src:'./images/ashkal16/13.png '},
{id:1,keynum:'0001',keyA:'n',src:'./images/ashkal16/7.png '},
{id:1,keynum:'0000',keyA:'o',src:'./images/ashkal16/15.png '},
{id:1,keynum:'1111',keyA:'p',src:'./images/ashkal16/16.png '},

]





export {isLogin,ramlKey}